import React, { useState, useEffect } from "react";
import Card from "common/components/Card/Card.jsx";
import CardHeader from "common/components/Card/CardHeader.jsx";
import CardIcon from "common/components/Card/CardIcon.jsx";
import CardBody from "common/components/Card/CardFooter.jsx";
import GridContainer from "common/components/Grid/GridContainer.jsx";
import GridItem from "common/components/Grid/GridItem.jsx";
import Grade from "@material-ui/icons/Grade";

import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";
import withStyles from "@material-ui/core/styles/withStyles";
import { useSelector } from "react-redux";

const importedStyle = dashboardStyle;
const styles = {
  cardIconTitle: importedStyle.cardIconTitle,
  upgradepromotext: {
    color: "red",
    marginLeft: 50,
  },
};

const UpgradePromoCard = (props) => {
  const { classes } = props;
  const [active, setActive] = useState(false);
  const [promoText, setPromoText] = useState("");
  const userid = useSelector((state) => state.services.ids.user);

  useEffect(() => {
    const upgradepromojson = window.localStorage.getItem(
      `upgradepromo${userid}`
    );

    if (upgradepromojson) {
      let upgradepromo = JSON.parse(upgradepromojson);
      if (Date.now() > upgradepromo.expires * 1000) {
        //Expired
        window.localStorage.removeItem("upgradepromo");
      } else {
        setPromoText(upgradepromo.upgradetext);
        setActive(true);
      }
    }
  }, [userid]);

  if (!active) {
    return null;
  }

  return (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="primary" icon>
            <CardIcon color="primary">
              <Grade />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>Active Offer</h4>
          </CardHeader>
          <CardBody>
            <h4 className={classes.upgradepromotext}>{promoText}</h4>
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
};

export default withStyles(styles)(UpgradePromoCard);
